module.exports = __webpack_public_path__ + "static/media/mx.cb47c8bf.svg";